import { getVigboUrl } from 'reactApp/modules/vigbo/vigbo.helpers';
import { getCurrentVigboAlbum } from 'reactApp/modules/vigbo/vigbo.selectors';
import { store as reduxStore } from 'reactApp/store';
import opener from 'reactApp/utils/opener';

export const setupVigboGallery = () => {
    const state = reduxStore.getState();
    const vigboAlbum = getCurrentVigboAlbum(state);

    if (!vigboAlbum) {
        return;
    }

    const params = { album_id: vigboAlbum.id };
    const setupVigboGallery = getVigboUrl('setupVigboGallery', params);
    if (!setupVigboGallery) {
        return;
    }

    opener(setupVigboGallery);
};
